import {
  MERCADOPAGO_ERROR,
  MERCADOPAGO_LOADING,
  MERCADOPAGO_SUCCESS,
  MERCADOPAGO_RESET,
  MERCADOPAGO_REFERENCIA,
  MERCADOPAGO_REFERENCIA_LOADING,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

export const wsGetMercadoPagoTurnos =
  (idturno, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_LOADING,
    });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/turnos/qr/${idturno}/${!idPacFamiliar ? "" : idPacFamiliar}`)
        .then((res) => {
          if (nextStep) nextStep(true, res.data);

          dispatch({
            type: MERCADOPAGO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          if (nextStep) nextStep(false, err.response.data);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoTurnos",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsGetMercadoPagoLaboratorio =
  (idprotocolo, idPacFamiliar, funLoading) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `/lis/laboratorio/${idprotocolo}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((res) => {
          funLoading(true);
          dispatch({
            type: MERCADOPAGO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          funLoading(false);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoLaboratorio",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsGetMercadoPagoReferencia =
  (referencia, nextStep) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_REFERENCIA_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/turnos/qr/referencia/${referencia}`)
        .then((res) => {
          if (nextStep) nextStep(true, res.data);
          dispatch({
            type: MERCADOPAGO_REFERENCIA,
            payload: res.data,
          });
        })
        .catch((err) => {
          if (nextStep) nextStep(false);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoLaboratorio",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const mercadoPagoReset = () => (dispatch) => {
  dispatch({
    type: MERCADOPAGO_RESET,
  });
};
